import {
    booleanAttribute,
    ChangeDetectionStrategy,
    Component,
    forwardRef,
    input,
    model,
    output,
    signal,
    ViewEncapsulation,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { InputSelectWrapperComponent } from '../input-select-wrapper/input-select-wrapper.component';
import { InputWrapperComponent } from '../input-wrapper/input-wrapper.component';

@Component({
    selector: 'ui-input-autocomplete',
    standalone: true,
    imports: [InputWrapperComponent, InputSelectWrapperComponent],
    templateUrl: './input-autocomplete.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => InputAutocompleteComponent), multi: true }],
})
export class InputAutocompleteComponent<T> implements ControlValueAccessor {
    value = model<string | null>(null);
    selectedValue = model<{ label: string; value: T }>();

    searchChange = output<string | null>();

    disabled = model(false);
    label = input('');
    error = input(false, { transform: booleanAttribute });
    errorMsg = input<string>();

    focussed = signal(false);
    open = signal(false);

    autocompleteOptions = input<Array<{ label: string; value: T }>>();

    _onChange?: (value: T) => void;
    _onTouch?: () => void;

    writeValue(value: { label: string; value: T }): void {
        this.selectedValue.set(value);
    }
    registerOnChange(fn: (value: T) => void) {
        this._onChange = fn;
    }
    registerOnTouched(fn: () => void) {
        this._onTouch = fn;
    }
    setDisabledState?(isDisabled: boolean) {
        this.disabled.set(isDisabled);
    }

    onInput(event: Event) {
        const value = (event.target as HTMLInputElement).value;
        this.searchChange.emit(value);
        this.value.set(value);
        if (!this.selectedValue()) this.selectedValue.set(undefined);
        this.open.set(true);
    }

    selectAutocomplete(option: { label: string; value: T }) {
        this.selectedValue.set(option);
        this._onChange?.(option.value);
        this.value.set(null);
        this.searchChange.emit(null);
        this.open.set(false);
    }

    onEnter() {
        const firstAutocompleteOption = this.autocompleteOptions()?.at(0);
        if (this.autocompleteOptions()?.length === 1 && firstAutocompleteOption) {
            this.selectAutocomplete(firstAutocompleteOption);
        }
    }
}
